import { z } from 'zod';
import { SUPPORTED_UNITS_SCHEMA } from '../quote-unit/unit-types.ts';
import { PRODUCT_CATEGORY_SCHEMA } from '../order-product/product-category.ts';
import { PartialCustomisedQuotePayloadByProductTypeSchema } from './quote-payload.ts';
import { CUSTOM_REQUEST_PRODUCT_TYPES_SCHEMA } from '../custom-request/mappings/custom-request-types.ts';

export const PatchQuoteFulfillmentUrlSchema = z.object({
    id: z.string().uuid(),
});

export const PatchQuoteFulfillmentRequestSchema = z
    .object({
        amount: z.number().optional(),
        unit: SUPPORTED_UNITS_SCHEMA.optional(),
        serviceDate: z.coerce.date().optional(),
        partnerOrganizationId: z.number().int().positive(),
        orderingOrganizationId: z.number().int().positive(),
        platformOrganizationId: z.number().int().positive().optional(),
        purchasePrice: z.number().optional(),
        purchaseTaxClassId: z.string().optional(),
        salesPrice: z.number().optional(),
        salesTaxClassId: z.string().optional(),
        productCategory: PRODUCT_CATEGORY_SCHEMA.optional(),
        productType: CUSTOM_REQUEST_PRODUCT_TYPES_SCHEMA.optional(),
    })
    .and(PartialCustomisedQuotePayloadByProductTypeSchema);
